<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>
                Assign Contact Data
                {{ campaignName != null ? campaignName : "" }}
              </h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6" v-if="showCampaignSelection">
            <div class="vx-col sm:w-1/6 w-full ml-5">
              <h6>Campaign :</h6>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignAutocomplete
                :key="companySearchComponentKey"
                class="searchbox"
                :list="searchCampaign"
                :searchOn="'campaign'"
                @event-name="selectCampaign"
              ></CampaignAutocomplete>
            </div>
          </div>
          <div v-if="showSalesDeveloperSubmit">
            <div class="vx-row mb-2">
              <div class="vx-col sm:w-1/6 w-full ml-5">
                <h6>Assign To :</h6>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <SalesDeveloperAutocomplete
                  :key="companySDSearchComponentKey"
                  class="searchbox"
                  :list="searchSalesDeveloper"
                  :searchOn="'selected_sales_developer'"
                  @event-name="handleSalesDeveloper"
                ></SalesDeveloperAutocomplete>
                <span class="text-danger text-sm">{{
                  please_choose_sales_developer
                }}</span>
              </div>
              <div class="vx-col sm:w-1/3 w-full">
                <vs-button @click.prevent="updateSalesDeveloperIds"
                  >Submit</vs-button
                >
              </div>
            </div>
          </div>
          <div v-if="showDatagrid">
            <DataGrid :context="'AssignSDQCContact'" 
              @sendSelectionToActualPage="sendSelectionToActualPage"
              ref="AssignSDQCContact"
              :columnDefs="contactColumnDefs"
              :rowData="contactRecords"
              :dataSource="contactDataSource"
              :rowSelection="'multiple'"
            >
            </DataGrid>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import vSelect from "vue-select";
import _ from "lodash";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import ContactAutocomplete from "@/components/autocomplete/ContactsAutocomplete.vue";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      showSalesDeveloperSubmit: false,
      showCampaignSelection: true,
      showDatagrid: false,

      companySDSearchComponentKey: 0,

      companySearchComponentKey: 0,

      please_choose_options: null,
      chooseExistingList: false,
      contactColumnDefs: [],
      please_choose_sales_developer: null,
      selected_campaign: null,
      contactDataSource: {},
      contactRecords: [],
      campaignId: null,
      campaignName: null,
      selected_table_ids: [],
      selected_sales_developer_id: null
    };
  },
  components: {
    "v-select": vSelect,
    DataGrid,
    ContactAutocomplete,
    CampaignAutocomplete,
    SalesDeveloperAutocomplete
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
  },
  mounted() {},
  watch: {},
  methods: {
    sendSelectionToActualPage(items) {
      let selected_table_ids = [];
      items.forEach(element => {
        selected_table_ids.push(element.table_id);
      });

      this.selected_table_ids = selected_table_ids;
      this.showSalesDeveloperSubmit = true;
    },
    updateSalesDeveloperIds() {
      let self = this;
      let data = {};
      data.table_ids = self.selected_table_ids;
      data.sales_developer_id = self.selected_sales_developer_id;
      data.campaign_id = self.campaignId;
      data.level = "contact";

      if (self.selected_sales_developer_id == null) {
        self.please_choose_sales_developer =
          "Please select sales developer to update";
      }

      if (
        self.selected_sales_developer_id != null &&
        self.selected_table_ids.length != 0 &&
        self.campaignId != null
      ) {
        self.$store
          .dispatch("campaignsManagement/updateSalesDeveloperIds", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.AssignSDQCContact.gridApi.deselectAll();

                self.$refs.AssignSDQCContact.gridApi.refreshServerSide({purge : true});
                self.getContactDataSource();
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    handleSalesDeveloper() {
      this.selected_sales_developer_id =
        moduleElomarkUserManagement.state.elomark_user.id;
      this.please_choose_sales_developer = null;
    },
    searchSalesDeveloper(inputValue) {
      let data = {};
      data.role = "Sales Developer";
      data.search = inputValue;
      data.campaign_id = this.campaignId;
      var self = this;
      return this.$store
        .dispatch("elomarkUsersManagement/getSalesDeveloperByCampaignId", data)
        .then(res => {
          let result = res.data;

          console.log("REEEE", result);

          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name +
                  "  -   " +
                  result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    selectCampaign() {
      let res = moduleCampaignManagement.state.campaign.datas;
      if (res) {
        this.selected_campaign = res[0];
      }
      this.campaignId = this.selected_campaign.id;
      this.campaignName = this.selected_campaign.campaign_name;
      this.selectCampaign2();
      this.$refs.AssignSDQCContact.gridApi.refreshServerSide({purge : true});
      this.getSDContactColumns();
      this.getContactDataSource();

      // console.log(this.selected_campaign)
    },
    selectCampaign2() {
      this.showDatagrid = true;
      this.getSDContactColumns();
      this.showCampaignSelection = false;
    },
    searchCampaign(inputValue) {
      this.please_choose_client = null;

      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(-1);
    },
    getContactDataSource() {
      var self = this;
      this.contactDataSource = {
        getRows(params) {
          params.request.campaignId = self.campaignId;
          params.request.campaignName = self.campaignName;

          self.$store
            .dispatch("accountsManagement/fetchAllSDQCContactsForAssignContact", params.request)
            .then(function(response) {
              let response_data = response.rows;


              response_data.forEach(function(ele) {
            for (const [key, value] of Object.entries(ele)) {
              if (key != "campaign_data_options") {

                if (ele[key] != null) {
                  if (Array.isArray(ele[key])) {

                    if (ele[key].length ==  0) {
                      ele[key] = null
                    }

                    else if (ele[key].length > 1) {

                      if( ele[key][0]["email"] != undefined ) {
                        ele[key] =  ele[key][0]["email"]
                        }

                      else if( ele[key][0]["ddi"] != undefined ) {
                        ele[key] =  ele[key][0]["ddi"]
                        }

                        else if( ele[key][0]["mobile"] != undefined ) {
                        ele[key] =  ele[key][0]["mobile"]
                        }

                        else if( ele[key][0]["social_media"] != undefined ) {
                        ele[key] =  ele[key][0]["social_media"]
                        }

                      

                    } else {
                      ele[key] = 'ΞΞ'
                    }
                   
                  } 

                }

              }
                }
          });

              // response_data.forEach(function(ele) {
              //   if (ele.contact_web) {
              //     if (ele.contact_web.length == 0) {
              //       ele.website = "";
              //     } else if (ele.contact_web.length > 1) {
              //       ele.website = "ΞΞ";
              //     } else {
              //       ele.website = ele.contact_web[0].url;
              //     }
              //   }
              // });

              // response_data.forEach(function(ele) {
              //   if (ele.contact_linkedin) {
              //     if (ele.contact_linkedin.length == 0) {
              //       ele.linkedin = "";
              //     } else if (ele.contact_linkedin.length > 1) {
              //       ele.linkedin = "ΞΞ";
              //     } else {
              //       ele.linkedin = ele.contact_linkedin[0].url;
              //     }
              //   }
              // });

              // response_data.forEach(function(ele) {
              //   if (ele.contact_phone) {
              //     if (ele.contact_phone.length == 0) {
              //       ele.phone = "";
              //     } else if (ele.contact_phone.length > 1) {
              //       ele.phone = "ΞΞ";
              //     } else {
              //       ele.phone = ele.contact_phone[0].phone_no;
              //     }
              //   }
              // });

             console.log("RESPONSE", response_data)

              if (response_data.length != 0) {
                self.$refs.AssignSDQCContact.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.AssignSDQCContact.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },

    getSDContactColumns() {
    var self = this;
    self.$store
      .dispatch(
        "campaignsManagement/getAllContactSelectedCampaignColumns",
        self.campaignId
      )
      .then(res => {
            let selected_columns = JSON.parse(res.data);


            selected_columns = selected_columns.filter(function(ele) {
              return ele.identifier != 'mobile_phone_code' && ele.identifier != 'ddi_phone_code' 
            });

            var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid

          
              ele.headerName = ele.name;


              if (ele.column_id != "contact_status" && ele.column_id != "contact_status_notes" && ele.column_id != "grade") {
                ele.field = '_' + ele.id.replaceAll("-", "_");

                if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

              }else{
                ele.field = ele.column_id;
              }



                if (ele.type == "date") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.contactColumnDefs = selected_columns

     

          let actions = {
            headerName: "Actions",
            field: "transactions",
            cellRenderer: "CellRendererActions",
            suppressHeaderMenuButton: true,
            checkboxSelection: true,

            pinned: true,
            width: 50
          };

          this.contactColumnDefs.push(actions);

          let sales_developer = {
            column_name: "sales_developer",
            field: "sales_developer",
            filter: "agTextColumnFilter",
            filterParams: {
              buttons: ["apply", "reset"],
              maxNumConditions: 4
            },
            headerName: "Sales Developer"
          };

          this.contactColumnDefs.push(sales_developer);

           var sorted = _.sortBy(this.contactColumnDefs, function(item) {
            return item.field === "sales_developer" ? 0 : 1;
          });

          this.contactColumnDefs = sorted;


      

      

      })
      .catch(err => {
        console.log(err);
      });
  },

  
  },
  beforeMount() {
    this.getSDContactColumns();
    this.getContactDataSource();
    self.$refs.AssignSDQCContact.gridApi.showNoRowsOverlay();
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
